import { render } from "./index.vue?vue&type=template&id=491de300&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=491de300&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491de300"],['__file',"resources/js/components/whatsapp-managment/includes/ReplyMessages/ReceivedReply/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "491de300"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('491de300', __exports__)) {
    console.log('reload')
    api.reload('491de300', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=491de300&scoped=true", () => {
    console.log('re-render')
    api.rerender('491de300', render)
  })

}


export default __exports__